import React from 'react';
import { useFunnel } from '../../contexts/FunnelContext';
import type { AccessInfo } from '../../types/funnel';
import { AccessEditor } from './AccessEditor';
import { StepHeading } from './StepHeading';
import { HelpAnswers } from './HelpAnswers';
import { BrandPhoto } from './BrandPhoto';
const note = {
  en: 'Stairs, elevators and long walks change how long a move takes and how we protect your home. That’s why we ask about each place separately.',
  es: 'Las escaleras, los elevadores y las caminatas largas cambian la duración de la mudanza y cómo protegemos su hogar. Por eso preguntamos por cada lugar por separado.'
};
const stopTitle = {
  en: (n: number, street: string) => `Stop ${n}${street ? ` — ${street}` : ''}`,
  es: (n: number, street: string) => `Parada ${n}${street ? ` — ${street}` : ''}`
};
export function StepAccess() {
  const {
    t,
    lang,
    data,
    update,
    updateAccess
  } = useFunnel();
  const multiUnit = data.homeType === 'apartment' || data.homeType === 'office';
  const patchStopAccess = (id: string, p: Partial<AccessInfo>) => update({
    stops: data.stops.map(s => s.id === id ? {
      ...s,
      access: {
        ...s.access,
        ...p
      }
    } : s)
  });
  return <div data-id="element-623" data-mp="2o721oqam4w0p">
      <StepHeading title={t('accessTitle')} intro={t('accessIntro')} data-id="element-624" data-mp="2o6sk9r3mvx6m" />
      <div className="mb-10 grid grid-cols-[1fr_1fr] gap-3 sm:grid-cols-[160px_160px_1fr] sm:items-center sm:gap-5" data-id="element-625" data-mp="2o4zfkhckzn19">
        <BrandPhoto role="stairs_access" alt="Crew member handling protected furniture at a staircase" className="aspect-[3/4] w-full rounded-xl" data-id="element-626" data-mp="3gvr3krjht5di" />
        {multiUnit ? <BrandPhoto role="elevator_access" alt="Crew member moving protected furniture at a building elevator" className="aspect-[3/4] w-full rounded-xl" data-id="element-627" data-mp="3bxfyeu457j1m" /> : <BrandPhoto role="floor_protection" alt="Staircase protected with moving blankets" className="aspect-[3/4] w-full rounded-xl" data-id="element-628" data-mp="32v6l5whhpbkj" />}
        <p className="col-span-2 text-[15px] leading-relaxed text-ink-600 sm:col-span-1" data-id="element-629" data-mp="1rgt1z4xolkau">{note[lang]}</p>
      </div>
      <div className="space-y-10" data-id="element-630" data-mp="1sy88yd21jy1u">
        <AccessEditor title={t('originHome')} access={data.origin} onChange={p => updateAccess('origin', p)} multiUnit={multiUnit} data-id="element-631" data-mp="1sz9tr98uzywr" />
        {data.stops.map((s, i) => <React.Fragment key={s.id} data-id="element-632" data-mp="1jxtmvbh96exa" data-mpi={i}>
            <div className="border-t border-ink-200" data-id="element-633" data-mp="1jwqx56vo2iiy" />
            <AccessEditor title={stopTitle[lang](i + 1, s.street)} access={s.access} onChange={p => patchStopAccess(s.id, p)} multiUnit data-id="element-634" data-mp="1nycd513hzcxd" />
          </React.Fragment>)}
        <div className="border-t border-ink-200" data-id="element-635" data-mp="1ey764s27ugjq" />
        <AccessEditor title={t('destHome')} access={data.destination} onChange={p => updateAccess('destination', p)} multiUnit={multiUnit} data-id="element-636" data-mp="1eyz4gan76sdp" />
      </div>
      <HelpAnswers screen="stepAccess" className="mt-10" data-id="element-637" data-mp="158dyg2572lkr" />
    </div>;
}